import React, { useContext } from 'react'

import { ContactContext } from 'contexts/contactContext'
import CompanyStaffsContextProvider from 'contexts/CompanyStaffsContext'

import StaffCollapses from './StaffsCollapses'

const Staff = () => {
  const { contact } = useContext(ContactContext)

  return (
    <CompanyStaffsContextProvider contactId={contact.id}>
      <StaffCollapses />
    </CompanyStaffsContextProvider>
  )
}

export default Staff
